export const HANDLE_ERROS_MESSAGE = [
  {
    error: 'Cnpj already used',
    message: 'Cpnj já cadastrado'
  }
]
